import gql from 'graphql-tag';
import { querySelector } from '../../../utils';

import { GetAllUserMonthBonusesForUserMonth } from './allUserMonthBonusUsersApi';
import { GetUserMonthBonusesForUserMonth } from './userMonthBonusesForUserMonthApi';

const SetStateAllUserMonthBonusesMutation = gql`
  mutation SetStateAllUserMonthBonuses($input: UserMonthBonusSetStateInput!) {
   user_month_bonus_set_state(input: $input) {
      id
    }
  }
`;

export const setStateAllUserMonthBonusesApprovalsApi = async (
  client,
  allUserMonthBonusesIdsArray,
  setNextState,
  bonusMonth,
  supervisorId,
  userId,
) => {
  const variables = {
    input: {
      state: setNextState,
      user_month_bonus_ids: allUserMonthBonusesIdsArray,
    },
  };

  const options = {
    mutation: SetStateAllUserMonthBonusesMutation,
    variables,
    refetchQueries: [
      {
        query: GetAllUserMonthBonusesForUserMonth,
        variables: { bonusMonth, supervisorId },
      },
      {
        query: GetUserMonthBonusesForUserMonth,
        variables: { bonusMonth, userId },
      },
    ],
  };

  const cachedQueryResults = client.readQuery({
    query: GetAllUserMonthBonusesForUserMonth,
    variables: { bonusMonth, supervisorId },
  });

  const oldCollection = querySelector(cachedQueryResults, '$.user_month_bonus_users[*].user', []);

  const result = await client.mutate(options);
  return {
    oldCollection,
    result,
  };
};
